var m365Products = [
    {
        title: 'Outlook apps',
        icon: 'Outlook',
        description: 'Work smarter with Outlook tools that help you communicate, manage your schedule, and find what you need—simply and fast.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'outlook'
            }
        }
    },
    {
        title: 'Teams apps',
        icon: 'Teams',
        description: 'Get even more productive with Teams, the one place for all your team needs: Chats, meetings, calls, files, and more.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'teams'
            }
        }
    },
    {
        title: 'Excel apps',
        icon: 'Excel',
        description: 'Get Excel add-ins to create order, unlock insights, and tell the story in your data.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'excel'
            }
        }
    },
    {
        title: 'Word apps',
        icon: 'Word',
        description: 'Better ways to read, write, collaborate, and present ideas from anywhere. Improve it even more with these custom add-ins.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'word'
            }
        }
    },
    {
        title: 'PowerPoint apps',
        icon: 'PowerPoint',
        description: 'Enhance PowerPoint with add-ins that build the story, present with clarity and conviction, and move forward faster.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'powerpoint'
            }
        }
    },
    {
        title: 'SharePoint apps',
        icon: 'SharePoint',
        description: 'Enhance your mobile, intelligent intranet. Share and manage content, knowledge, and applications to empower teamwork.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'sharepoint'
            }
        }
    },
    {
        description: 'Create personalized employee experiences that connect, engage, and grow your organization in the flow of work using Microsoft Viva.',
        title: 'Viva apps',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'viva'
            }
        },
        icon: 'Viva'
    },
    {
        title: 'OneNote apps',
        icon: 'OneNote',
        description: 'OneNote is the digital note-taking app for all your devices. Enhance OneNote with Office 365 add-ins.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'onenote'
            }
        }
    },
    {
        title: 'Project apps',
        icon: 'Project',
        description: 'Deliver winning projects. Integrated planning tools help you keep track of projects and stay organized.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'project'
            }
        }
    },
    {
        title: 'Office apps',
        icon: 'Office',
        description: 'Enhance your Office app, the hub for all your content.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'office'
            }
        }
    }
];

export { m365Products };
